<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Usuários'" :novo="novo" :titulo="contentEdit.nome" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-5 form-group">
          <label>Nome:</label>
          <input
            type="text"
            v-model="contentEdit.nome"
            name="nome"
            id="nome"
            class="form-control required valid"
            value
          />
        </div>        
        <div class="col-4 form-group">
          <label>E-mail:</label>
          <input
            type="email"
            v-model="contentEdit.email"
            name="email"
            id="email"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-md-3 form-group">
          <label>Administrador:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.administrador == true}"
            >
              <input type="radio" name="administrador" id="adminsitradorativo" @change="fnAtiva('administrador',true)" :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.administrador == false}"
            >
              <input type="radio" name="administrador" id="adminsitradorinativo"  @change="fnAtiva('administrador',false)"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
       <div class="col-5 form-group">
          <label>Login:</label>
          <input
            type="text"
            v-model="contentEdit.login"
            name="login"
            id="login"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-2 form-group" >
          <label>Nova senha</label>
          <input
            type="password"
            v-model="alterarSenha"
            name="senha"
            id="senha"
            class="form-control required valid"
            value
          />
        </div>
          <div class="col-2 form-group" >
          <label>Confirme a senha</label>
          <input
            type="password"
            v-model="confirmeSenha"
            name="senha"
            id="senha"
            class="form-control required valid"
            value
          />
        </div>         

        <div class="col-md-3 form-group">
          <label>Perito:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.perito == true}"
            >
              <input type="radio" name="perito" id="peritoativo" @change="fnAtiva('perito')" :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.perito == false}"
            >
              <input type="radio" name="perito" id="peritoinativo"  @change="fnAtiva('perito')"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.ativo == true}"
            >
              <input type="radio" name="ativo" id="ativo" @change="fnAtiva('')" :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.ativo == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @change="fnAtiva('')"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
        <div class="col-sm-12">
          <hr />
        </div>
        <div class="col-3 form-group">
          <small>Criado em:</small>
          <small v-if="contentEdit.tsInclusao">
            <b>{{formatData(contentEdit.tsInclusao)}}</b>
          </small>
        </div>
        <div class="col-3 form-group">
          <small>Alterado em:</small>
          <small v-if="contentEdit.tsAlteracao">
            <b>{{contentEdit.tsAlteracao}}</b>
          </small>
        </div>
        <div class="col-6 text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
    <div>{{temErro}}</div>
  </div>
</template>

<script>
import Tbheader from "../../_include/_headerTabelas";
import { getData,getSuccess,getError } from "../../../global/utils";

export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: "",
      suporteAtivo: true,
      success: false,
      error:null,
      alterarSenha:null,
      confirmeSenha:null,
      contentEdit: {
        nome:'',
        senha:null,
        ativo: false,
        perito:false
      },
    };
  },
  components: { Tbheader },
  methods: {
    fnLimpa(){
      this.contentEdit.nome = ''
      this.contentEdit.ativo = ''
      this.contentEdit.perito = ''
      this.contentEdit.senha = null
      this.contentEdit.administrador = false
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva(value) {
        if(value == "perito"){
         this.contentEdit.perito = !this.contentEdit.perito
        }else if(value == "administrador"){
          this.contentEdit.administrador = !this.contentEdit.administrador
        }else{
          this.contentEdit.ativo = !this.contentEdit.ativo
        }
    },
    fnCancela(){
        this.$router.push({path: "/paineldegerenciamento/listausuarios"})
    },
    async formSubmit(e) {
        e.preventDefault();
        if(this.alterarSenha != this.confirmeSenha){
          this.$toasted.global.defaultError({msg:"Senhas não conferem!"})
        }else{
          this.contentEdit.senha = this.alterarSenha
          const metodo = this.$route.params.id ? 'put' : 'post'
          const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''
          let data = await this.$http[metodo]("/listausuarios" + completaUrl,this.contentEdit)
          .then(() =>{
              getSuccess();
              this.fnLimpa();
              this.fnCancela();
          })
        .catch(e => {
          return  e
          }); 
          this.error = data
          this.$vs.loading.close()
        }


    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
    let data = await getData(this.urlApi+"/listausuarios/"+valueId);
      this.contentEdit = data[0].content;
    },   
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },        
  mounted() {
      this.$store.commit("navSector",'tabela')
  },

};
</script>

<style lang="scss" scoped>

</style>